import React from 'react';
import './style.css';
import { Chart } from "react-google-charts";

// export const options = {
//     title: "",
//     curveType: "function",
//     pieSliceText : 'value',
//     sliceVisibilityThreshold: 0,
//     legend: { position: "bottom" },
//     colors: ['#FFBF00', '#008000','#BFBF00' ,'#EE4B2B']

//   };

  export const data = [
    ["Week", "Sales"],
    ["Sun", 1000],
    ["Mon", 1170],
    ["Tue", 2660],
    ["Wed", 10030],
    ["Thrus", 1170],
    ["Fri", 6690],
    ["Sat", 1030]
  ];
  
  export const options = {
    title: "Sales Performance by week",
    curveType: "function",
    legend: { position: "right" },
  };


 const SalesCard=({chartData})=>{

    
    return <div className='col-xxl-4 col-md-6'>
        <div class="graph-card ">
        <div class="card-body">
        <h5 class="card-title">{'Sales'} <span>| {'Week'}</span></h5>
        <Chart
      chartType="LineChart"
      data={data}
      options={options}
      width={"100%"}
      height={"400px"}
    />
        </div>
    </div>
    </div>
}
export default SalesCard